export const getPersistentContextBarPositionClass = (containedDesktop) => (
  containedDesktop ? 'relative' : 'sticky top-20'
);
